import React, { useEffect, useState } from 'react'
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
} from '@material-ui/core'
import { Translate } from 'react-localize-redux'
import MultiSelect from 'components/material/MultiSelect'
import { Input, SelectedMenu } from 'components'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  filterDataFromToday,
  formatCostumDateMonthNoForUI,
} from 'utils/formatDate'
import PropTypes from 'prop-types'
import { events as eventsModule } from '../../redux/modules'
import AddEditQuestions from './AddEditQuestions'
import { TRAININGS_GAME } from 'constants/calender'
import { TASK_GROUP_DUE_DATES } from 'constants/taskGroups'

const AddEditTrainingTaskGroup = ({
  taskGroup,
  isEditMode,
  playersList,
  handleInput,
  handlePlayerChange,
  handleCreate,
  handleUpdate,
  questions,
  handleQuestion,
  addNewQuestion,
  setQuestions,
  setTaskGroup,
  handleCheckboxSelectAllPlayers,
  selectAllPlayers,
  match: {
    params: { seasonId },
  },
  fetchCalendarEvents,
  dateFormat,
  eventId,
}) => {
  const [trainings, setTrainings] = useState([])
  const [selectedPlayers, setSelectedPlayer] = useState([])
  const [selectedTrainings, setSelectedTrainings] = useState([])
  const [selectAllEvents, setSelectAllEvents] = useState(eventId <= 0)

  const filterTrainings = (data) => {
    // Filter out dates in the past or falsey values
    return filterDataFromToday(data.map((d) => ({ ...d, date: d.event_date })))
  }
  const handleCheckboxSelectAllTrainings = (event) => {
    const { checked } = event.target

    setSelectAllEvents(checked)
    if (checked) {
      const filteredTrainings = filterTrainings(trainings)

      setTaskGroup({
        ...taskGroup,
        eventUuids: [...new Set(filteredTrainings.map((p) => p.uuid))],
        [`error_eventUuids`]: filteredTrainings.length <= 0,
      })
      setSelectedTrainings(filteredTrainings)
    }
  }
  const handleEventChange = (value) => {
    setTaskGroup({
      ...taskGroup,
      eventUuids: [...new Set(value.map((p) => p.uuid))],
      [`error_eventUuids`]: value.length <= 0,
    })
    setSelectedTrainings(value)
  }

  useEffect(() => {
    fetchCalendarEvents(seasonId).then((res) => {
      const response = res.response.data
      const tempTrainings = response.events
        .filter((s) => s.relation === 'training')
        .map((training) => ({
          id: training.uuid,
          uuid: training.uuid,
          label: `${formatCostumDateMonthNoForUI(
            training.date,
            dateFormat
          )} Focus: ${training.training_focus ? training.training_focus : ''}`,
          event_date: training.date,
        }))
      setTrainings(tempTrainings)

      const isSelectAllEvents =
        taskGroup && taskGroup?.eventUuids?.length > 0
          ? taskGroup?.eventUuids?.length === tempTrainings?.length
          : eventId <= 0

      setSelectAllEvents(isSelectAllEvents)
      if (isSelectAllEvents) {
        const filteredTrainings = filterTrainings(tempTrainings)

        setTaskGroup({
          ...taskGroup,
          eventUuids: [...new Set(filteredTrainings.map((t) => t.uuid))],
          [`error_eventUuids`]: filteredTrainings.length <= 0,
        })
        setSelectedTrainings(filteredTrainings)
      } else {
        setSelectedTrainings(
          eventId
            ? tempTrainings.filter(
                (training) =>
                  eventId === training.uuid
              )
            : tempTrainings.filter((training) =>
                taskGroup?.eventUuids?.includes(training.uuid)
              )
        )

        if (eventId > 0) {
          setTaskGroup({
            ...taskGroup,
            eventUuids: [
              ...tempTrainings
                .filter(
                  (training) =>
                    taskGroup?.eventUuids?.includes(training.uuid) ||
                    eventId === training.uuid
                )
                .map((p) => p.uuid),
            ],
          })
        }
      }
    })
  }, [])

  useEffect(() => {
    setSelectedPlayer(
      playersList.filter((player) => taskGroup?.modelUuids?.includes(player.uuid))
    )
  }, [taskGroup.modelUuids])

  return (
    <Grid container alignItems="center">
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={selectAllEvents}
              onChange={handleCheckboxSelectAllTrainings}
              color="secondary"
            />
          }
          label={<Translate id="task-management.all-trainings" />}
          disabled={!!eventId}
        />
        {!selectAllEvents && (
          <MultiSelect
            options={trainings}
            handleSelection={handleEventChange}
            label={<Translate id="task-management.select-training" />}
            selectedValues={selectedTrainings}
            error={taskGroup?.error_eventUuids}
            helperText={
              taskGroup?.error_eventUuids && (
                <Translate id="task-management.training-validation" />
              )
            }
            limitTags={5}
            disabled={!!eventId}
          />
        )}
        <FormControlLabel
          control={
            <Checkbox
              checked={selectAllPlayers}
              onChange={handleCheckboxSelectAllPlayers}
              color="secondary"
            />
          }
          label={<Translate id="task-management.visible-to-all" />}
        />
        {!selectAllPlayers && (
          <MultiSelect
            options={playersList}
            handleSelection={handlePlayerChange}
            label={<Translate id="task-management.select-player" />}
            selectedValues={selectedPlayers}
            error={taskGroup?.error_modelUuids}
            helperText={
              taskGroup?.error_modelUuids && (
                <Translate id="task-management.player-validation" />
              )
            }
          />
        )}

        <Input
          label={<Translate id="articles.title" />}
          margin="dense"
          onChange={handleInput}
          name="title"
          value={taskGroup?.title}
          error={taskGroup?.error_title}
          helperText={
            taskGroup?.error_title && (
              <Translate id="task-management.title-validation" />
            )
          }
          required
        />

        <Input
          label={<Translate id="drills.description" />}
          margin="dense"
          onChange={handleInput}
          name="description"
          value={taskGroup.description}
        />
        <SelectedMenu
          id="due-date"
          name="dueDateOffset"
          value={taskGroup.dueDateOffset}
          margin="dense"
          onChange={handleInput}
          label={<Translate id="task-management.due-date" />}
        >
          {TASK_GROUP_DUE_DATES.map((p) => (
            <MenuItem key={p.value} value={p.value}>
              {p.title}
            </MenuItem>
          ))}
        </SelectedMenu>
      </Grid>
      <AddEditQuestions
        questions={questions}
        handleQuestion={handleQuestion}
        addNewQuestion={addNewQuestion}
        setQuestions={setQuestions}
        taskGroup={taskGroup}
        setTaskGroup={setTaskGroup}
      />

      <Button
        onClick={
          !isEditMode
            ? () => handleCreate(TRAININGS_GAME.training)
            : () => handleUpdate(TRAININGS_GAME.training, taskGroup.uuid)
        }
        color="primary"
        variant="contained"
        style={{ marginTop: '1.5rem' }}
        fullWidth
        disabled={
          taskGroup?.error_title ||
          taskGroup?.error_modelUuids ||
          taskGroup?.error_eventUuids
        }
      >
        {!isEditMode ? (
          <Translate id="button.add" />
        ) : (
          <Translate id="button.update" />
        )}
      </Button>
    </Grid>
  )
}

AddEditTrainingTaskGroup.defaultProps = {
  eventId: 0,
  match: {
    params: {},
  },
}

AddEditTrainingTaskGroup.propTypes = {
  taskGroup: PropTypes.shape().isRequired,
  isEditMode: PropTypes.bool.isRequired,
  handleInput: PropTypes.func.isRequired,
  handlePlayerChange: PropTypes.func.isRequired,
  handleCreate: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  playersList: PropTypes.arrayOf(PropTypes.shape().isRequired).isRequired,
  questions: PropTypes.arrayOf(PropTypes.shape().isRequired).isRequired,
  handleQuestion: PropTypes.func.isRequired,
  addNewQuestion: PropTypes.func.isRequired,
  setQuestions: PropTypes.func.isRequired,
  setTaskGroup: PropTypes.func.isRequired,
  handleCheckboxSelectAllPlayers: PropTypes.func.isRequired,
  selectAllPlayers: PropTypes.bool.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape(),
  }),
  fetchCalendarEvents: PropTypes.func.isRequired,
  dateFormat: PropTypes.string.isRequired,
  eventId: PropTypes.number,
}

export default compose(
  withRouter,
  connect(
    ({ team, auth }) => ({
      team,
      dateFormat: auth.user.datetime_format,
    }),
    {
      fetchCalendarEvents: eventsModule.fetchCalendarEvents,
    }
  )
)(AddEditTrainingTaskGroup)
